import { Plugin } from 'ckeditor5/src/core';
import FileUploadEditing from './fileuploadediting';
import FileUploadUI from './fileuploadui';
export default class FileUploader extends Plugin {
    static get requires() {
        return [FileUploadEditing, FileUploadUI];
    }
    static get pluginName() {
        return 'FileUploader';
    }
}
